import React, { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { UtensilsCrossed, MapPin, Phone } from "lucide-react";
import { Layout } from "../components/Layout";
import { SponsorSlot } from "../components/SponsorSlot";
import { useI18n } from "../i18n";
import * as apiClient from "../api";

const CATS = { seafood: "Pesce", traditional: "Tradizionale Gargano", pizza: "Pizza", fine: "Fine dining", family: "Family", aperitivo: "Aperitivo", romantic: "Romantico" };

export default function Restaurants() {
  const { t } = useI18n();
  const { data: all = [] } = useQuery({ queryKey: ["restaurants"], queryFn: apiClient.getRestaurants });
  const [filter, setFilter] = useState("");
  const list = filter ? all.filter((r) => r.category === filter) : all;

  return (
    <Layout>
      <div className="bg-gradient-to-b from-slate-50 to-white border-b border-slate-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-10">
          <div className="text-xs font-bold uppercase tracking-[0.2em] text-secondary mb-2 flex items-center gap-2"><UtensilsCrossed className="h-4 w-4" /> Dove Mangiare</div>
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-heading font-semibold tracking-tight text-slate-900">I sapori di Vieste</h1>
          <div className="mt-6 flex gap-2 overflow-x-auto no-scrollbar pb-2">
            <button onClick={() => setFilter("")} className={`shrink-0 rounded-full px-4 py-2 text-sm font-medium ${!filter ? "bg-primary text-white" : "bg-white border border-slate-200 text-slate-600"}`}>Tutti</button>
            {Object.entries(CATS).map(([k, label]) => (
              <button key={k} onClick={() => setFilter(k)} className={`shrink-0 rounded-full px-4 py-2 text-sm font-medium ${filter === k ? "bg-primary text-white" : "bg-white border border-slate-200 text-slate-600"}`}>{label}</button>
            ))}
          </div>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-10">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {list.map((r) => (
            <div key={r.id} data-testid={`restaurant-${r.id}`} className="bg-white rounded-2xl overflow-hidden border border-slate-100 shadow-sm hover-lift">
              <div className="relative h-48 overflow-hidden">
                <img src={r.image} alt={r.name} className="h-full w-full object-cover img-zoom" loading="lazy" />
                <span className="absolute top-3 left-3 rounded-full bg-white/90 px-3 py-1 text-xs font-semibold text-primary">{CATS[r.category]}</span>
              </div>
              <div className="p-5">
                <h3 className="font-heading font-semibold text-lg text-slate-900">{r.name}</h3>
                <p className="text-sm text-slate-500 mt-1">{r.description}</p>
                <div className="mt-3 flex items-center gap-3 text-xs text-slate-400">
                  <span className="flex items-center gap-1"><MapPin className="h-3 w-3" />{r.location}</span>
                </div>
                <a href={`tel:${r.phone}`} className="mt-4 inline-flex items-center gap-2 rounded-full bg-primary/5 text-primary text-sm font-semibold px-4 py-2 hover:bg-primary hover:text-white transition-colors"><Phone className="h-3.5 w-3.5" /> Prenota tavolo</a>
              </div>
            </div>
          ))}
        </div>
      </div>
      <SponsorSlot placement="RISTORANTI" className="pb-14" />
    </Layout>
  );
}
